/*
 * Code generated by Speakeasy (https://speakeasy.com). DO NOT EDIT.
 */

import { imagePostImageNsfw } from "../../funcs/imagePostImageNsfw.js";
import { PostImageNsfwRequest$zodSchema } from "../../models/postimagensfwop.js";
import { formatResult, ToolDefinition } from "../tools.js";

const args = {
  request: PostImageNsfwRequest$zodSchema,
};

export const tool$imagePostImageNsfw: ToolDefinition<typeof args> = {
  name: "image-post-image-nsfw",
  description: `图片敏感检测

这是一个图片内容审核接口，自动识别图片中的违规内容并返回处理建议。

> [!VIP]
> 此接口限时免费开放，无需企业认证即可使用。

## 功能概述
上传图片文件或提供图片URL，接口会自动分析图片内容，返回是否违规、风险等级和处理建议。适合对接到用户上传流程中，实现自动化内容审核。

## 返回字段说明
- **is_nsfw**: 是否判定为违规内容，\`true\` 表示违规，\`false\` 表示正常
- **nsfw_score**: 违规内容置信度，0-1 之间，越高表示越可能违规
- **normal_score**: 正常内容置信度，0-1 之间，与 nsfw_score 互补
- **suggestion**: 处理建议
  - \`pass\`: 内容正常，可以直接放行
  - \`review\`: 存在风险，建议转人工复核
  - \`block\`: 高风险内容，建议直接拦截
- **risk_level**: 风险等级
  - \`low\`: 低风险
  - \`medium\`: 中风险
  - \`high\`: 高风险
- **label**: 内容标签，\`nsfw\` 或 \`normal\`
- **confidence**: 模型对当前判断的整体置信度
- **inference_time_ms**: 模型推理耗时，单位毫秒`,
  scopes: ["read"],
  annotations: {
    "title": "",
    "destructiveHint": false,
    "idempotentHint": false,
    "openWorldHint": true,
    "readOnlyHint": true,
  },
  args,
  tool: async (client, args, ctx) => {
    const [result] = await imagePostImageNsfw(
      client,
      args.request,
      { fetchOptions: { signal: ctx.signal } },
    ).$inspect();

    if (!result.ok) {
      return {
        content: [{ type: "text", text: result.error.message }],
        isError: true,
      };
    }

    return formatResult(result.value);
  },
};
